import Footer from "../../Common/Footer/Index";
import HomeBanner from "./Banner";
import './../../../app.scss';
import './homepage.scss';
import Technologies from "./Technologies";

const Homepage = () => {
    return (
        <>
            <HomeBanner />
            <div className="globalContainerPadding container-fluid homeMidSection">
                <div className="row">
                    <div className="col-12 col-sm-8 homeIntro">
                        <p>I enjoy venture new dimensions of work, places and people.</p>
                        <p>I have experience in Gen AI Technologies, Prompt Engineering, Architecture Design & Development, Full Stack Development & Web technologies. I have a proven prowess in the fields of Architecture design, Technical Solutions, Customer Interaction, business development & strategy.</p>
                        <p>I am exploring Python, FastAPI and LLM Models to create GenAI based applications.</p>
                        <p>I love being busy with my family, camera and plants, if not doing anything!</p>
                        <ul>
                            <li><a href='https://www.linkedin.com/in/rkrandhir/' class="linkedIn" target="_blank" rel="noopener noreferrer">
                                My LinkedIn Profile</a></li>
                            <li><a href='https://github.com/rkrandhir' class="gitHub" target="_blank" rel="noopener noreferrer">My GitHub Page</a></li>
                        </ul>
                    </div>
                    <div className="col-12 col-sm-4 homeTech">
                        <h3>Technologies</h3>
                        <Technologies />
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Homepage;